import { render, staticRenderFns } from "./SystemMessageBox.vue?vue&type=template&id=f337d5b2&scoped=true&"
import script from "./SystemMessageBox.vue?vue&type=script&lang=js&"
export * from "./SystemMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageBox.vue?vue&type=style&index=0&id=f337d5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f337d5b2",
  null
  
)

export default component.exports